import { UiSchema } from '@rjsf/utils'

import { FormProperties } from '../../imup/types'

export const FloorTrussType = 'Floor Truss'
export const Truss = 'Truss'
export const FlatRoofTruss = 'Flat Roof Truss'
export const TraditionalTruss = 'Traditional Truss (Rafter and Joist)'
export const uiSchema: UiSchema = {}

const onValidate = () => {}

const onSubmit = (settings, formData) => {
    return {
        ...settings,
        ...formData,
    }
}

const form: FormProperties = { uiSchema, onValidate, onSubmit }

export default form
